export default {
    app: {
        loading: 'Načítání...',
    },
    global: {
        units: {
            thousand: 'tis.',
            million: 'mil.',
            billion: 'mld.',
            trillion: 'bil.',
        },
        currency: {
            czk: 'Kč',
            kč: 'Kč',
            eur: '€',
            points: '{points} bodů',
        },
        days: {
            today: 'Dnes',
            tomorrow: 'Zítra',
        },
    },
    header: {
        menuContent: {
            movies: 'Filmy',
            cinestarClub: 'CineStar Club',
            events: 'Akce',
        },
        chooseCinemaContent: {
            title: 'Potvrďte předvybrané kino nebo zvolte jiné',
        },
        shoppingCart: {
            tickets: '{count, plural, one {Vstupenka} few {Vstupenky} other {Vstupenek}}',
            minutes: '{count, plural, one {Minuta} few {Minuty} other {Minut}}',
        },
    },
    orderSteps: {
        first: 'Výběr místa',
        second: 'Vaše objednávka',
        third: 'Kontaktní údaje',
        fourth: 'Shrnutí <span>objednávky</span> a platba',
        fourthRes: 'Shrnutí <span>rezervace</span> a potvrzení',
    },
    userProfile: {
        title: 'Staňte se členem {br}CineStar Clubu',
        description:
            'Díky členství dostanete okamžitou slevu 20 Kč na každou vstupenku. Za každou útratu sbíráte body, které proměníte za volnou vstupenku nebo občerstvení ZDARMA.',
        buttonOrder: 'OBJEDNAT ČLENSTVÍ ONLINE',
        cardValidity: 'Vaše členství vyprší',
        cardValidityExpired: 'Vaše členství vypršelo',
        menuBar: {
            ticketAndReservation: 'Nákup a rezervace vstupenek',
            cinestarClub: 'CineStar Club',
            lostCard: 'Ztráta karty',
            contactInfo: 'Kontaktní údaje',
            passChange: 'Změna hesla',
        },
        ticketsAndReserv: {
            title: 'Nákup a rezervace vstupenek',
            ticket: 'Vstupenka',
            tickets: 'Vstupenky',
            orderNumber: 'Číslo objednávky',
            reservationNumber: 'Číslo rezervace vstupenek',
        },
        cinestarClub: {
            title: 'CineStar Club',
            clubNachos: 'Klubové nachos menu zdarma',
            missingPoints: 'K získání odměny nasbírejte ještě {points} bodů.',
            coupons: {
                title: 'Kupóny',
                noCoupons: 'Nemáte žádné kupóny',
            },
            rewards: {
                title: 'Odměny',
                noRewards: 'Nemáte žádné odměny',
            },
            pointsOverview: {
                title: 'Přehled bodů',
                currentStatus: 'Aktuální bodový stav',
                date: 'Datum',
                purchase: 'Nákup',
                points: 'Body',
                loadMore: 'Načíst další',
            },
        },
    },
    hall: {
        hallHeader: {
            changeTime: 'Změnit čas',
            dateAndVenue: '{date}, {venue}',
            hallPicture: 'Info o sálu',
            'gold-class': {
                title: 'GOLD CLASS',
                description: 'GOLD CLASS description',
            },
            deluxe: {
                title: 'THEATRE DELUXE',
                description: 'THEATRE DELUXE description',
            },
            default: {
                title: 'Běžný sál',
                description: 'běžný sál',
            },
            subtitles: 'Titulky',
        },
        legend: {
            title: 'Legenda',
            zoom: 'Zvětšit',
            move: 'Posunout',
            seat: {
                classic: {
                    single: 'Klasické sedadlo',
                    double: 'Dvojsedadlo',
                },
                vip: {
                    single: 'VIP sedadlo',
                    double: 'VIP dvojsedadlo',
                },
                gold: {
                    single: 'Gold sedadlo',
                    double: 'Gold dvojsedadlo',
                },
                deluxe: {
                    single: 'Deluxe sedadlo',
                    double: 'Deluxe dvojsedadlo',
                },
                wheelchair: {
                    single: 'Místo pro vozíčkáře',
                    double: 'Místo pro vozíčkáře',
                },
                positionable: {
                    single: 'Polohovatelné',
                    double: 'Polohovatelné',
                },
                selected: {
                    single: 'Vybráno',
                    double: 'Vybráno',
                },
                reserved: {
                    single: 'Obsazeno',
                    double: 'Obsazeno',
                },
            },
            seatDescription: {
                material: 'Materiál',
                width: 'Šířka',
                classic: {
                    single: 'seatDescription Klasické sedadlo',
                    double: 'seatDescription Dvojsedadlo',
                    material: 'classic material',
                    singleWidth: '50cm',
                    doubleWidth: '100cm',
                },
                vip: {
                    single: 'seatDescription VIP sedadlo',
                    double: 'seatDescription VIP dvojsedadlo',
                    material: 'vip material',
                    singleWidth: '50cm',
                    doubleWidth: '100cm',
                },
                gold: {
                    single: 'seatDescription GOLD sedadlo',
                    double: 'seatDescription GOLD dvojsedadlo',
                    material: 'gold material',
                    singleWidth: '50cm',
                    doubleWidth: '100cm',
                },
                deluxe: {
                    single: 'seatDescription Deluxe sedadlo',
                    double: 'seatDescription Deluxe dvojsedadlo',
                    material: 'deluxe material',
                    singleWidth: '50cm',
                    doubleWidth: '100cm',
                },
                wheelchair: {
                    single: 'seatDescription Místo pro vozíčkáře',
                    double: 'seatDescription Místo pro vozíčkáře',
                    material: 'wheelchair material',
                    singleWidth: '50cm',
                    doubleWidth: '100cm',
                },
                positionable: {
                    single: 'seatDescription Polohovatelné',
                    double: 'seatDescription Polohovatelné',
                    material: 'positionable material',
                    singleWidth: '50cm',
                    doubleWidth: '100cm',
                },
            },
        },
        screen: 'Plátno',
    },
    basket: {
        btn: 'Pokračovat',
        selectedSeats: 'Vybrané sedačky',
        totalPrice: 'Celková cena:',
        totalPriceReservation: 'Celková cena rezervace:',
        textOnlineReservation: 'Cena při platbě na pokladně, online nebo na kiosku:',
        textCashReservation: 'Cena při platbě na pokladně',
        reserveText: 'Cena uhrazení rezervace na pokladně  +{amount} {currency}',
        reserveBtn: 'Rezervovat',
        buyBtn: 'Koupit',
        paymentBtn: 'Zaplatit',
        reservationBtn: 'Rezervovat',
        moneySaved: 'Právě jste ušetřili <span>{price}</span> za nákup online',
    },
    yourOrder: {
        nextFilm: 'Další film',
        tickets: {
            title: 'Vyberte typ vstupenky:',
        },
        addTickets: {
            title: 'Přidejte vstupenky na další film:',
            text: 'Přidat vstupenky',
        },
        addSnackCoupon: 'Přidejte si do objednávky občerstvení',
        throwAway: 'Zahodit?',
    },
    contactInfo: {
        haveAccount: 'Mám účet',
        withoutLogin: 'Bez přihlášení',
        buyWithoutLogin: 'Nakoupím bez přihlášení',
    },
    orderSummary: {
        ticketsDescription: {
            seat: 'Sedadlo',
            type: 'Typ',
            price: 'Cena',
            paymentPoints: 'Platba body',
            totalPrice: 'Celková cena objednávky',
            totalAmount: '{amount} Kč',
            maxTicketsLine: 'Klubovou slevu lze uplatnit maximálně na 4 vstupenky',
            extendMembershipLine: 'Členství v CineStar Clubu na 1 rok',
            voucherApplied: 'Poukázka uplatněna',
        },
        haveAvailable: 'Máte k dispozici',
        getSale: 'Získejte slevu 20 Kč na každou vstupenku.',
        giftVoucher: {
            title: 'Uplatnit dárkový poukaz',
            info: 'Lze zadat opakovaně',
            byPhoto: 'Vyfotit / nahrát kód',
            byHand: 'Zadat ručně',
            number: 'Číslo poukazu',
        },
        goods: {
            membership: {
                title: 'Členství',
                description: 'CineStar Club na 1 rok',
            },
            meal: {
                title: 'Občerstvení',
            },
        },
        paymentMethod: 'Vyberte způsob platby',
        downloadAppTitle: 'Zaplaťte v aplikaci a ušetřete {price}.',
        downloadAppDesc:
            'Pokud zaplatíte rezervaci v mobilní aplikaci, dostanete dodatečnou slevu {price} za platbu v aplikaci.',
    },
    forms: {
        required: 'Toto pole je povinné',
        register: {
            title: 'Registrace',
            orFillText: 'Nebo vyplňte',
            nameLabel: 'Jméno',
            namePlaceholder: 'Jméno',
            nameError: 'jméno chyba',
            surnameLabel: 'Příjmení',
            surnamePlaceholder: 'Příjmení',
            surnameError: 'příjmení chyba',
            phoneLabel: 'Telefon',
            phonePlaceholder: '789 123 456',
            phoneError: 'Telefonní číslo musí odpovídat formátu 123456789 nebo 123 456 789',
            emailLabel: 'E-Mail',
            emailPlaceholder: 'E-Mail',
            emailError: 'Zadaný e-mail není platný',
            passwordLabel: 'Heslo',
            passwordPlaceholder: 'Zadejte vaše heslo',
            passwordError: 'Heslo chyba',
            passwordConfLabel: 'Heslo znovu',
            passwordConfPlaceholder: 'Pro kontrolu',
            passwordConfError: 'Chybí potvrzení hesla',
            passwordMatchesEmail: 'Heslo se nesmí shodovat s e-mailovou adresou',
            passwordsMustMatch: 'Hesla se musí shodovat',
            checkboxLabel: 'Souhlasím s <span>Všeobecnými obchodními podmínkami</span>',
            checkBoxNotChecked: 'Musíte souhlasit s Všeobecnými obchodními podmínkami',
            buttonCreateMemberAccount: 'STÁT SE ČLENEM CINESTAR CLUBU',
            buttonCreateBasicAccount: 'Vytvořit účet',
            clubMemberBenefits: {
                title: 'Staňte se členem CineStar Clubu a čerpejte výhody',
                benefitDiscount: 'Sleva 20 Kč na každou vstupenku',
                benefitRewards: 'Sbírejte body za nakoupené vstupenky a občerstvení a vyberte si odměny zdarma.',
                benefitPoints: 'Za samotnou registraci dostanete hned 10 bodů.',
                feeText: 'Za členství v CineStar Clubu zaplatíte ročně 120 Kč.',
            },
            cinestarClubMember: {
                title: 'Pro dokončení  registrace v CineStar Clubu vyplňte prosím ještě tyto údaje:',
                gender: 'Pohlaví',
                man: 'Muž',
                woman: 'Žena',
                other: 'Jiné',
                dateLabel: 'Datum narození',
                datePlaceholder: 'Datum narození',
                dateError: 'Chyba v datu',
                residenceLabel: 'Bydliště',
                residencePlaceholder: 'Město',
                residenceError: 'Chyba v bydlišti',
                postalCodeLabel: 'PSČ',
                postalCodePlaceholder: 'PSČ',
                postalCodeError: 'Chyba v PSČ',
                agreement: {
                    title: 'Váš souhlas',
                    description:
                        'Seznámil/a jsem se s <memberLink> podmínkami věrnostního programu CineStar Clubu </memberLink>, <conditions> Všeobecnámi obchodními podmínkami </conditions> a <personalData> podmínkami pro zpracování osobních údajů </personalData>. Osobní údaje jsou zpracovávány a chráněny ve smyslu zákona č.110/2019 Sb., ozpracování osobních údajů a Nařízení Evropského parlamentu a rady (EU) č.2016/679 o ochraně fyzických osob v souvislosti se zpracováním osobních údajů o volném pohybu těchto údajů.',
                    checkboxLabel: 'Souhlasím se zasíláním <link>obchodních sdělení partnerů CineStar</link>',
                    description2:
                        'Registrací souhlasíte s našimi Všeobecnými podmínkami a Zásadami ochrany osobních údajů',
                },
                buttonBecomeMember: 'VYTVOŘIT ÚČET A STÁT SE ČLENEM CINESTAR CLUBU',
            },
            errorLabel: 'Chyba',
            errorText: 'Při registraci se vyskytla chyba. Zkuste to prosím později.',
        },
        login: {
            title: 'Přihlášení',
            orFillText: 'Nebo vyplňte',
            emailLabel: 'E-Mail',
            emailPlaceholder: 'E-Mail',
            emailError: 'Zadaný e-mail není platný',
            passwordLabel: 'Heslo',
            passwordPlaceholder: 'Napište vaše heslo',
            passwordError: 'Chybně zadané heslo',
            buttonLogin: 'PŘIHLÁSIT',
            buttonForgotten: 'Zapomněli jste heslo?',
            buttonCreate: 'Vytvořit účet',
            unknownEmail: 'Nesprávný e-mail',
            wrongPassword: 'Nesprávné heslo',
            internalErrorLabel: 'Chyba',
            internalErrorText: 'Omlouváme se, došlo k interní chybě serveru. Na odstranění chyby pracujeme.',
        },
        contactInfo: {
            title: 'Kontaktní údaje',
        },
        agreements: {
            title: 'Vaše souhlasy',
            description:
                'Svým souhlasem stvrzuji, že jsem se seznámil/a s podmínkami věrnostního programu CineStarClubu a s podmínkami zpracování osobních údajů. Osobní údaje jsou zpracovány a chráněny ve smyslu zákona č. 101/2000 Sb. a Nařízení o ochraně osobních údajů č. 679/2016. Souhlas se zpracováním osobních údajů pro zasílání obchodních sdělení a dalších marketingových aktivit (formou e-mailů, sms, notifikací):',
            nonPersonal: 'Souhlas se zasíláním nepersonalizované reklamy',
            personal:
                'Souhlas se zasíláním personalizované reklamy: abychom Vám mohli zasílat informace a reklamu, které odpovídají Vašim osobním zájmům, analyzujeme Vaše zakoupené vstupenky, Vaši účast na našich reklamních akcích a Vaše využívání našich elektronických služeb. Pro tyto účely zpracováváme následující osobní údaje: email, věk, pohlaví, nákupní chování. místo nákupu(multikino), filmové nebo jiné představení, kategorie filmu, doba účasti, frekvence navštívených filmů, zjištění podobnosti s jinými našimi zákazníky.',
            checkBoxNotChecked: 'Musíte zvolit jednu z možnosti.',
        },
        lostCard: {
            title: 'Ztráta karty',
            description: 'Ztratili jste nebo vám někdo ukradl kartu CineStar Clubu? Tady vám ji zablokujeme.',
            label: 'Potvrzuji, že chci zablokovat kartu CineStar Clubu',
            checkBoxNotChecked: 'Se zablokováním karty musíte souhlasit.',
        },
        changePassword: {
            title: 'Změna hesla',
            oldPasswordLabel: 'Původní heslo',
            oldPasswordPlaceholder: 'Zadejte původní heslo',
            oldPasswordError: 'Chyba původního hesla',
            newPasswordLabel: 'Nové heslo',
            newPasswordPlaceholder: 'Zadejte nové heslo',
            newPasswordError: 'Nové heslo je nesprávné',
            confirmationPasswordLabel: 'Zadejte nové heslo znovu',
            confirmationPasswordPlaceholder: 'Pro kontrolu',
            confirmationPasswordError: 'Chyba hesla pro kontrolu',
            invalidPassword: 'Heslo není platné',
            passwordMatchesEmail: 'Heslo nesmí být stejné jako e-mailová adresa',
            passwordsMustMatch: 'Hesla se musí shodovat',
        },
        changeForgottenPassword: {
            title: 'Změna hesla',
            newPasswordLabel: 'Nové heslo',
            newPasswordPlaceholder: 'Zadejte vaše heslo',
            newPasswordError: 'chyba hesla',
            confirmationPasswordLabel: 'Zadejte znovu nové heslo',
            confirmationPasswordPlaceholder: 'Pro kontrolu',
            confirmationPasswordError: 'Zadané heslo je nesprávné',
            buttonChange: 'ZMĚNIT HESLO',
            buttonCancel: 'Zrušit',
            invalidPassword: 'Heslo není platné',
            passwordMatchesEmail: 'Heslo nesmí být stejné jako e-mailová adresa',
            passwordsMustMatch: 'Hesla se musí shodovat',
            error: {
                text: 'Nebyli jsme schopni změnit heslo. Prosím zkuste to znovu později.',
                notValid: 'Vypršela platnost odkazu.',
            },
        },
        forgottenPassword: {
            title: 'Zapomenuté heslo',
            emailLabel: 'Zadejte váš registrační e-mail.',
            emailPlaceholder: 'E-Mail',
            emailError: 'email chyba',
            buttonSend: 'POSLAT NOVÉ HESLO',
            buttonCancel: 'ZRUŠIT',
        },
        passwordValidation: {
            length: 'Musí obsahovat 8 až 16 znaků.',
            letter: 'Alespoň jedno písmeno.',
            number: 'Alespoň jednu číslici.',
            email: 'Není shodné s e-mailovou adresou.',
        },
        customBenefitPayment: {
            introLabel: 'Zadejte platební údaje',
            cardNumberLabel: 'Číslo karty',
            cardNumberPlaceholder: 'Zadejte číslo karty',
            pinLabel: 'PIN',
            pinPlaceholder: 'Zadejte PIN',
        },
    },
    modals: {
        modalUrlError: {
            title: 'Chybná URL',
            text: 'Odkaz bohužel nefunguje. Url adresa neobsahuje veškeré nutné parametry k tomu, aby načetla daný sál.',
        },
        modalCinemaChange: {
            title: 'Změna kina',
            text: `Došlo ke změně kina, ve kterém nakupujete. Předchozí nákup jste nedokončili. Při pokračování v novém nákupu bude váš původní košík vysypán. Chcete vysypat košík?`,
            backBtn: 'Dokončit předešlou objednávku',
            continueBtn: 'Vysypat košík a udělat novou objednávku',
        },
        modalBasketChange: {
            title: 'Změna košíku',
            text: 'Bohužel nejde současně nakoupit vstupenky a dárkové poukazy. Při pokračování v novém nákupu bude váš původní košík vysypán. Chcete vysypat košík?',
            backBtn: 'Dokončit předešlou objednávku',
            continueBtn: 'Pokračovat a vysypat košík',
        },
        modalRestoreToCard: {
            title: 'Úprava rezervace',
            text: 'Potřebujete upravit nebo uhradit tuto rezervaci? Rezervace bude zrušena a převedena do aktivního košíku, kde můžete vytvořit novou rezervaci nebo si lístky rovnou koupit. Chcete pokračovat?',
            backBtn: 'Zpět',
            continueBtn: 'Pokračovat',
        },
        modalPayReservation: {
            title: 'Zaplacení rezervace',
            text: 'Upozornění. Proces platby rezervace je nutné v dalších krocích dokončit, jinak bude rezervace stornována. Přejete si pokračovat?',
            backBtn: 'Zpět',
            continueBtn: 'Pokračovat',
        },
        modalCinemaSelect: {
            title: 'Vyberte kino',
            text: 'Pro pokračování prosím vyberte kino.',
        },
    },

    windows: {
        success: {
            title: 'Úspěch',
            successful: 'Vše proběhlo v pořádku.',
            contactInfo: 'Vaše kontaktní údaje jsme úspěšně změnili.',
            GDPR_CHANGE: 'Úspěšně jsme provedli změnu u zásad zpracování osobních údajů.',
            CONTACT_INFO_CHANGE: 'Změnili jsme vaše kontaktní údaje.',
            lostCard: 'Klubovou kartu jsme zablokovali.',
            registerClub: 'Žádost do CineStar Clubu byla úspěšně odeslána.',
            PASSWORD_CHANGED: 'Změna hesla proběhla úspěšně.',
            changeForgottenPassword: 'Změna hesla proběhla úspěšně. Budete automaticky přesměrováni za 3 sekundy.',
            CHANGE_FORGOTTEN_PASSWORD: 'Změna hesla proběhla úspěšně. Budete automaticky přesměrováni za 3 sekundy.',
            forgottenPassword: 'Na e-mail jsme vám odeslali odkaz pro změnu hesla.',
            FORGOTTEN_PASSWORD: 'Na e-mail jsme vám odeslali odkaz pro změnu hesla.',
            GIFT_VOUCHER_SUCCESS: 'Vaši dárkovou poukázku jsme úspěšně načetli.',
            REGISTER_CLUB_SUCCESS: 'Odeslané údaje jsme zpracovali, nyní můžete dokončit a zaplatit objednávku.',
            ACCOUNT_CREATED: 'Právě jsme vám vytvořili účet',
            LOGOUT: 'Byli jste odhlášeni.',
            CANCEL_RESERVATION: 'Zrušili jsme vaši rezervaci',
            CANCEL_ORDER: 'Zrušili jsme vaši objednávku',
            IMAGE_UPLOAD: 'Obrázek byl nahrán',
        },
        info: {
            title: 'Info',
            ticketTypes: {
                title: 'Typy vstupenek',
                type: {
                    child: 'Dítě',
                    student: 'Student',
                    senior: 'Senior',
                    ztp: 'ZTP, ZTP/P',
                },
                description: {
                    child: 'Do 12 let včetně. Dítě do 3 let nemusí platit vstupné, nemá ale nárok na vlastní sedačku.',
                    student: 'S platným studentským průkazem do 26 let včetně',
                    senior: 'Nad 60 let včetně',
                    ztp: 'Doprovod (jedna osoba) pro ZTP/P  má vstupenku zdarma. Pro slevu ZTP nebo ZTP/P musíte předložit platný průkaz.',
                },
            },
        },
        notification: {
            title: 'Upozornění',
            paidTitle: 'Zaplaceno',
            noTicketsReserv: 'Aktuálně nemáte zakoupené žádné vstupenky ani rezervace',
            referenceNumber: 'Referenční číslo události: {referenceNumber} (uschovejte prosím pro případnou reklamaci)',
            ticketsReserved:
                'Nezapomeňte si rezervaci vyzvednout v kiosku nebo na pokladně kina, alespoň 30 minut před představením.',
            lights: 'Upozorňujeme, že tento film obsahuje několik scén, ve kterých silně bliká světlo. Pokud trpíte fotosenzitivní epilepsií nebo máte zvýšenou citlivost na světlo, zvažte svou účast na představení .',
            onlyCards: 'Z technických důvodů můžete platit pouze platebními kartami.',
            withoutPoints: 'Na toto představení není možné využít body z věrnostního programu CineStar Club.',
            notShared: 'Na tento film si vstupenky bohužel online  koupit nemůžete.',
            needUserInfo: 'Pro dokončení objednávky je nutné se přihlásit nebo zadat kontaktní údaje.',
            reservedTickets:
                'Rezervaci zaplatíte na pokladně nebo kiosku. <bold>Vstupenky musíte zaplatit 30 minut před představením, jinak  rezervaci automaticky stornujeme.</bold>',
            reservationPaid: 'Tuto objednávku už máte zaplacenou.',
            cantReserveWithMeal: 'Rezervaci vám bohužel kvůli přidanému občerstvení nemůžeme udělat.',
            TOO_MANY_SEATS: 'Nemůžete si vybrat více než 6 sedadel',
            WHEELCHAIR: 'Vybrané místo je pro vozičkáře, není zde sedadlo k sezení!',
            BOOKING_NOT_ALLOWED:
                'Na toto představení není možné si vstupenky jen rezervovat - ale můžete si je rovnou pohodlně koupit online.',
            CANT_DOWNLOAD_ALL_VOUCHERS: 'Některé kupóny jsou již uplatněné',
        },
        loading: {
            title: 'Načítám',
            wait: 'Počkejte chvíli prosím.',
        },

        error: {
            title: 'Chyba',
            somethingWrong: 'Omlouváme se, ale došlo k chybě v systému. Zkuste to znovu později.',
            E_WS_PASSWORD_CHECK_FAILED: 'Heslo jste zadali špatně, zkuste to prosím znovu.',
            forgottenPassword:
                'Bohužel se nám nepodařilo odeslat vaši žádost o resetování hesla. Zkuste to prosím znovu později.', //TODO add right error instead of forgottenPassword
            TOKEN_EXPIRED: 'Platnost relace vypršela, protože jste dlouho na stránce nic neudělali.',
            TOKEN_MISSING: 'Platnost relace vypršela, zkuste stránku aktualizovat nebo se vraťte na předchozí krok.',
            TOKEN_FAILED: 'Platnost relace vypršela, zkuste stránku aktualizovat nebo se vraťte na předchozí krok.',
            E_WS_LOGIN_EXISTS: 'Účet pod tímto e-mailem už existuje.',
            CANT_READ_QR_CODE:
                'Tento QR kód jsme bohužel nenačetli. Zkontrolujte prosím, že jste nahráli správný QR kód.',
            NO_PAYMENT_DATA: 'Abyste uskutečnili objednávku, musíte vyplnit platební údaje.',
            CANT_APPLY_GIFT_VOUCHER: 'Tento dárkový poukaz byl už uplatněný a nebo jste jej špatně zadali.',

            VOUCHER_ERROR_1: 'Zadaný kód kupónu neexistuje',
            VOUCHER_ERROR_2: 'Kupón už byl využit',
            VOUCHER_ERROR_3: 'Platnost kupónu vypršela',
            VOUCHER_ERROR_4: 'Kupón ještě nebyl aktivován',
            VOUCHER_ERROR_5: 'Kupón byl stornován',
            VOUCHER_ERROR_9: 'Tento kupón nelze uplatnit na webu',
            VOUCHER_ERROR_10: 'Kupón nelze použít pro vybrané představení',

            TOO_BIG: 'Obrázek je příliš velký',

            EMAIL_ALREADY_USED: 'Tento email je již používán existujícím účtem. Prosím přihlaste se do svého účtu.',

            E_REGISTER_EMAIL_FIRST:
                'Email zatím není zaregistrován, pro přihlášení přes sociální stě, je potřeba se nejprpve registrovat',

            E_API_AUTHORIZATION_FAILED: 'Zadali jste špatně přihlašovací údaje, zkuste je prosím znovu napsat.',
            TICKET_UNAVAILABLE: 'Některá z vámi vybraných sedadel už vybral někdo jiný. Vyberte si prosím jiná.',
            EMAIL_TICKET_ERROR:
                'Bohužel se nám nepodařilo vám odeslat vstupenky na váš e-mail. Vstupenky si ale můžete jednoduše stáhnout ve vašem profilu. Pokud potřebujete pomoci, kontaktujte zákaznickou podporu.',
            CANT_LOAD_MEAL_VOUCHERS_LIST:
                'Bohužel se nám nepodařilo načíst nabídku občerstvení. Zkuste stránku aktualizovat nebo to zkuste za pár minut.',
            E_API_LOGIN_NOT_EXISTS:
                'Omlouváme se, ale zadaný e-mail není propojený s žádným účtem. Zkontrolujte prosím svůj e-mail a zkuste to znovu.', // Chyba pro /forgotten-password když je zadán neexistující email
            DOWNLOAD_FAIL:
                'Je nám to líto, ale nepodařilo se nám stáhnout vaše vstupenky a vouchery. Zuste to znovu později nebo kontaktujte naši zákaznickou podporu.',
            DOWNLOAD_EMPTY_VOUCHERS: 'Veškeré kupóny byly již uplatněny',
            API_TOKEN_MISSING: 'Omlouváme se, ale vaše relace vypršela. Přihlaste se znovu, abyste mohli pokračovat.',
            API_TOKEN_FAILED: 'Omlouváme se, ale vaše relace vypršela. Přihlaste se znovu, abyste mohli pokračovat.',
            E_API_TOKEN_NOT_FOUND:
                'Omlouváme se, ale vaše relace vypršela. Přihlaste se znovu, abyste mohli pokračovat.',
            E_LP_POINTS_EXCEEDED: 'Je nám to líto, ale momentálně nemáte dostatek bodů pro uskutečnění.',
            E_TICKET_FOR_VOUCHER_1_AND_1_NOT_FOUND:
                'Prosím, zkontrolujte svou objednávku a přidejte potřebný počet vstupenek.',
            API_PAY_BY_POINTS_NOT_ALLOWED:
                'Omlouváme se, ale na tuto objednávku nemůžete body uplatnit. Vyberte si jinou platební metodu.',
            API_PAY_BY_POINTS_PAYMENT_NOT_DEFINED_OR_SUPPORTED:
                'Omlouváme se, ale na tuto objednávku nemůžete body uplatnit. Vyberte si jinou platební metodu.',
            E_API_BOOKING_CANCEL_STATE: 'Omlouváme se, ale tato rezervace už neplatí. Můžet si ale vytvořit novou.',
            E_API_BOOKING_CANCEL_DISABLED:
                'Omlouváme se, ale tuto rezervaci nelze stornovat. Pokud máte jakkékoliv dotazy, kontaktujte zákaznickou podporu.',
            API_CART_IS_EMPTY_OR_RELEASED:
                'Omlouváme se, ale váš nákupní košík je prázdný. Přidejte si požadovaný produkt do košíku a pak pokračujte k platbě.',
            API_CART_PAYMENT_NOT_SELECTED: 'Vyberte typ platby.',
            API_CART_PERSON_DATA_MISSING: 'Přihlaste se nebo vyplňte osobní údaje.',
            E_API_CARD_ALREADY_IN_CART: 'Tuto položku už máte v košíku.',
            API_REGISTRATION_PASSWORD:
                'Omlouváme se, přihlášení se nezdařilo. Zkontrolujte vaše heslo a zkuste to znovu.',
            API_REGISTRATION_EMAIL:
                'Omlouváme se, přihlášení se nezdařilo. Zkontrolujte své přihlašovací údaje a zkuste to znovu.',
            API_REGISTRATION_NAME_SURNAME:
                'Omlouváme se, přihlášení se nezdařilo. Zkontrolujte své přihlašovací údaje a zkuste to znovu.',
            API_REGISTRATION_PHONE:
                'Omlouváme se, přihlášení se nezdařilo. Zkontrolujte telefonní číslo a zkuste to znovu.',
            API_CHANGE_PASSWORD_EMPTY:
                'Omlouváme se, změna hesla se nezdařila. Zkontrolujte, zda jste vše vyplnili správně a zkuste to znovu.',
            E_API_ALREADY_AUTHORIZED: 'Omlouváme se, ale uživatel je už přihlášen.',
            E_WS_ACCOUNT_NOT_ACTIVE: 'Omlouváme se, ale přihlášení se nezdařilo. Váš účet není aktivní.',
            E_API_CATEGORY_NOT_SHARED: 'Omlouváme se, ale tato kategorie není povolená.',
            E_API_ACCOUNT_ALREADY_EXISTS:
                'Účet s tímto e-mailem už existuje. Pokud si myslíte, že jde o chybu, kontaktujte naši zákaznickou podporu.',
            API_AUTHORIZATION_FAILED:
                'Omlouváme se, ale přihlášení se nezdařilo. Prosím, zkontrolujte své přihlašovací údaje a zkuste to znovu.',
            API_ITEM_OCCUPIED: 'Omlouváme se, ale tato položka už není k dispozici. Prosím, vyberte si jinou.',
            API_VALIDITY_EXCEEDED: 'Omlouváme se, ale tuto rezervaci už nelze vytvořit.',
            API_LOGIN_EXISTS:
                'Omlouváme se, ale tento účet už existuje. Pokud si myslíte, že se jedná o chybu, kontaktujte naši zákaznickou podporu.',
            NO_TICKET_VOUCHER: 'Vyplňte číslo voucheru.',
            API_NO_TICKET_FOR_VOUCHER_FOUND:
                'Dárkový poukaz nelze uplatnit: buď nebyl rozpoznán, již byl uplatněn, nebo jej upltňujete na zlevněné vstupné či alternativní program.',
            E_API_BOOKING_RESTORE_CINEMA: 'Rezervaci nelze obnovit, rezervace je do jiného kina, než máte nastaveno.',
        },
        warning: {
            TOO_MANY_SEATS: 'Omlouváme se, ale nelze vybrat více než 6 sedadel najednou.',
            DIFFERENT_CINEMA: 'Změnili jste lokaci kina, a proto jsme vám z košíku odebrali vstupenky.',
        },
    },
    paymentVerify: {
        paymentIsBeingVerified: 'Chvilku strpení, vaši platbu momentálně ověřujeme.',
    },
    thanksForOrder: {
        title: 'Děkujeme za vaši objednávku {id}. Užijte si ten nejlepší kino zážitek v celé galaxii.',
        subtitle: '{item} právě zamířily do vaší e-mailové schránky.',
        subtitle2: 'Potvrzení objednávky najdete ve svém účtě nebo v zaslaném emailu.',
        subtitle3: 'Potvrzení rezervace bylo odesláno na Váš email.',
        findThem: 'Najdete ji také ve <redirect>vašem účtě</redirect>.',
        sendThem: 'Poslat vstupenky formou SMS',
    },
    ticketsReserved: {
        title: 'Děkujeme za vaši rezervaci {id}. Užijte si ten nejlepší kino zážitek v celé galaxii.',
    },
    page404: {
        pageTitle: 'Kosmíku, máme problém!',
        title: 'Vesmír nás překvapuje každý den',
        description: 'Dnes nás překvapil tím, že jsme nenašli vaši stránku.',
        button: 'Zpět na hlavní stránku',
    },
    page500: {
        pageTitle: 'Neočekávaná chyba',
        title: 'Houstone, máme problém.',
        description: 'Zdá se, že jsme ztratili spojení se serverem.',
        button: 'Zpět na stránky CineStar',
    },
    maintenance: {
        pageTitle: 'Udržba',
        title: 'Stránka není dostupná.',
        description: 'Pracujeme na údržbě stránky.',
        button: 'Zpět na stránky CineStar',
    },
    appError: {
        pageTitle: 'Neočekávaná chyba',
        title: 'Omlouváme se,',
        description: '... ale aplikace neočkávaně selhala. Zkuste to prosím později.',
        button: 'Zpět na stránky CineStar',
    },
    paymentFailed: {
        pageTitle: 'Online platba se nezdařila',
        title: 'Něco se pokazilo. Bohužel nedošlo k uhrazení platby.',
        description:
            'Máte 2 možnosti, jak tento problém vyřešit. Objednávku můžete zrušit a uvolníte  sedadla jiným zákazníkům. Nebo se vrátíte do objednávky a zvolíte jiný způsob doručení a platby.',
        button1: 'Změnit způsob platby',
        button2: 'Zrušit objednávku',
    },
    expiredLimit: {
        pageTitle: 'Je nám to líto, ale platnost stránky vypršela.',
        title: 'Překročili jste časový limit pro dokončení vašeho nákupu.',
        description: 'Vyberte si prosím znovu vámi vybraný film a sedačky.',
        button: 'ZPĚT NA VÝBĚR PŘEDSTAVENÍ',
    },
    ticket: {
        type: {
            basic: 'Základní',
            child: 'Dítě',
            student: 'Student',
            senior: 'Senior',
            ztp: 'ZTP',
            club: 'CineStar Club na 1 rok',
        },
        pointPayment: 'Uplatnit {points} bodů',
    },
    buttons: {
        yes: 'Ano',
        no: 'Ne',
        back: 'Zpět',
        close: 'Zavřít',
        continue: 'POKRAČOVAT',
        login: 'Přihlásit se',
        register: 'Registrovat',
        logout: 'Odhlásit se',
        add: 'Přidat',
        confirm: 'POTVRDIT',
        confirmVoucher: 'OVĚŘIT POUKAZ',
        buttonSave: 'ULOŽIT ZMĚNY',
        chooseCinema: 'Vybrat kino',
        downloadTickets: 'Stáhnout vstupenky',
        downloadVouchers: 'Stáhnout vouchery',
        cancelOrder: 'Zrušit objednávku',
        downloadApp: 'Stáhnout aplikaci',
        send: 'ZASLAT',
        apply: 'UPLATNIT',
        extendMembership: 'Prodloužit <span>členství</span>',
        extendMembershipRemove: 'Odebrat prodloužení členství',
        orderMembership: 'Objednat členství online',
        orderMembershipRemove: 'Zrušit objednávku členství',
        social: 'Pokračovat s <spanCapitalize>{variant}</spanCapitalize>',
        goToAccount: 'Přejít na účet',
        moreInfo: 'Více informací',
        payReservation: 'Zaplatit rezervaci',
        cancelReservation: 'Zrušit rezervaci',
        restoreToCard: 'Upravit rezervaci',
        downloadReservation: 'Stáhnout rezervaci',
        toggle: {
            label: {
                basic: 'Základní',
                child: 'Dítě',
                student: 'Student',
                senior: 'Senior',
                ztp: 'ZTP',
                Dítě: 'Dítě',
                Senior: 'Senior',
                Student: 'Student',
                ZTP: 'ZTP',
                'CineStar Club': 'CineStar Club',
                'Dítě CineStar Club': 'Dítě CineStar Club',
                'Student CineStar Club': 'Student CineStar Club',
                'Senior CineStar Club': 'Senior CineStar Club',
            },
        },
    },
    demo: {
        title: 'Demo stránka',
        typography: 'Typography component demo',
    },
    mailSender: {
        forgottenPassword: {
            subject: 'CineStar - Zapomenuté heslo',
            content: 'Pro změnu hesla klikněte na odkaz:',
        },
    },
    footer: {
        copyright: {
            advertising: 'Exkluzivním prodejcem reklamy je agentura Cinexpress',
            regulations: 'Návštěvní řád',
            terms: 'Podmínky zpracování osobních údajů',
            conditions: 'Všeobecné obchodní podmínky',
            cinestar: 'CineStar s.r.o. © {year}',
            designBy: 'Design by Symbio',
        },
    },
}
